/**
 * PostHog Analytics Constants
 * Centralized tracking event names and error type identifiers
 *
 * Error naming convention:
 * Every captureException call sends these fields that map to Slack notifications:
 *   error_name             → Slack title (bold)    - [Bracket Prefix] context - message
 *   original_error_message → Slack description     - Raw JS/library error message, unmodified
 *   error_context          → Slack endpoint field  - Where it happened (endpoint, component, handler)
 *   error_type             → PostHog Error.name    - Broad category shown as type prefix in PostHog UI
 *
 * Bracket prefixes come from the constants below. No magic strings.
 */

// Event names for tracking user actions
export const ANALYTICS_EVENTS = {
  AUTH_LOGIN: 'auth_login',
  AUTH_LOGOUT: 'auth_logout',
  AUTH_BOUNCE_LOOP_DETECTED: 'auth_bounce_loop_detected',
  ARRIVED_FROM_COMPANY_LOGIN: 'Arrived from company login',
  SHOWED_THE_LOGIN_SCREEN: 'Showed the login screen',
  OPENED_THE_APP: 'Opened the app',
  SIGN_IN_FAILED: 'Sign-in failed',
  COMPANY_LINK_NOT_RECOGNIZED: 'Company login link not recognized',
  ARRIVED_FROM_DIRECT_LINK: 'Arrived from a direct login link',
  ARRIVED_SIGNED_OUT: 'Arrived signed out',
  AUTH0_RETURNED_AN_ERROR: 'Auth0 returned an error',
  STOPPED_A_SIGN_IN_LOOP: 'Stopped a sign-in loop',
}

/**
 * ERROR_TYPES serves two purposes with a single value:
 * 1. Broad categories used as error_type → becomes Error.name in PostHog UI (e.g. "Vue Error: ...")
 * 2. Bracket prefix in error_name when no more specific prefix exists
 *
 * Specific bracket prefixes (SSO_LOGIN, QUERY_PARAM) are used only
 * in error_name for detail; their broad error_type is SSO or AUTH respectively.
 */
export const ERROR_TYPES = {
  // Broad categories (error_type for PostHog Error.name grouping)
  API: 'API Request Error',
  AUTH: 'Authentication Error',
  VUE: 'Vue Error',
  SSO: 'SSO Error',
  UNCAUGHT: 'Uncaught Error',

  // Specific bracket prefixes for error_name (error_type uses broad category above)
  SSO_LOGIN: 'SSO Login Error',
  QUERY_PARAM: 'Query Param Error',

  VERSION_CONTROL: 'Version Control Error',
}

// API-layer error types - used as bracket prefixes in error_name
export const API_ERRORS = {
  REQ_ERROR: 'API Request Error',
  AUTH_EXPIRED: 'Authentication Expired',
  CORS_ERROR: 'CORS Error',
  NETWORK_ERROR: 'Network Error',
  LOGIN_AUTH_ERROR: 'Login Auth0 Error',
  LOGOUT_AUTH_ERROR: 'Logout Auth0 Error',
}
